// Utility functions for text formatting

/**
 * Convert text to title case (proper case)
 * @param {string} str - The string to convert
 * @returns {string} - The title cased string
 */
export const toTitleCase = (str) => {
  if (!str || typeof str !== 'string') return str;

  return str
    .toLowerCase()
    .split(' ')
    .map((word) => {
      // Handle common abbreviations and special cases
      const upperCaseWords = [
        'ltd',
        'llc',
        'inc',
        'corp',
        'plc',
        'uk',
        'usa',
        'eu',
        'vat',
        'id',
        'no',
        'tel',
        'fax',
      ];
      const lowerCaseWords = [
        'and',
        'or',
        'but',
        'nor',
        'for',
        'yet',
        'so',
        'a',
        'an',
        'the',
        'in',
        'on',
        'at',
        'by',
        'to',
        'of',
      ];

      if (upperCaseWords.includes(word.toLowerCase())) {
        return word.toUpperCase();
      }

      // Don't capitalize small words unless they're the first word
      if (lowerCaseWords.includes(word.toLowerCase()) && str.indexOf(word) !== 0) {
        return word.toLowerCase();
      }

      // Capitalize first letter of each word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

/**
 * Handle input change with title case conversion for text fields
 * @param {Event} e - The input event
 * @param {Function} setFormData - The state setter function
 * @param {Object} formData - The current form data
 * @param {Array} titleCaseFields - Array of field names to apply title case to
 */
export const handleTitleCaseChange = (e, setFormData, formData, titleCaseFields = []) => {
  const { name, value, type, checked } = e.target;
  let processedValue = type === 'checkbox' ? checked : value;

  // Apply title case to specified text fields
  if (type === 'text' && titleCaseFields.includes(name) && typeof processedValue === 'string') {
    processedValue = toTitleCase(processedValue);
  }

  setFormData({
    ...formData,
    [name]: processedValue,
  });
};
